import { render, staticRenderFns } from "./techprocessesMainView.vue?vue&type=template&id=01c80114&scoped=true&"
import script from "./techprocessesMainView.vue?vue&type=script&lang=js&"
export * from "./techprocessesMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c80114",
  null
  
)

export default component.exports